const mEditionBillingAcademyProyects = {
  mEditionBillingAcademyProyects: {
    alerts: {
      readAcademy: {
        error: 'La academia que busca con ese url no existe'
      }
    },

    tooltip: {
      restart: 'Actualizar'
    }
  }
}

export default mEditionBillingAcademyProyects
